module.exports = __webpack_public_path__ + "media/PtownConCommHearing20190305_2.2cafd972.mp4";